module.exports = __webpack_public_path__ + "img/us.23f7a60f.svg";